import { defaultClient as httpClient } from '../utils/http'

import * as EntityConverter from './entity/converter'

import moment from 'moment'

//const modelToEntity = (model) => ({
//  ...model,
//  // format address
//  post_code: `${model.zipcode_upper}-${model.zipcode_lower}`,
//  prefectures: model.state,
//  town: model.street,
//  address: model.building,
//  zipcode_upper: undefined,
//  zipcode_lower: undefined,
//  state: undefined,
//  street: undefined,
//  building: undefined,
//  //
//  construction_start: model.construction_start
//    ? model.construction_start
//    : moment(
//        `${model.construction_start_year}-${model.construction_start_month}-01T00:00:00Z`,
//      ).toISOString(),
//  construction_start_year: undefined,
//  construction_start_month: undefined,
//  //
//  completion_date: model.completion_date
//    ? model.completion_date
//    : moment(
//        `${model.completion_year}-${model.completion_month}-01T00:00:00Z`,
//      ).toISOString(),
//  completion_year: undefined,
//  completion_month: undefined,
//})

export const loadActiveAndPermissions = () => {
  return httpClient
    .post('/user/details')
    .then(({ data }) => data)
    .then(({ code, data, message, active_project_id = null }) => {
      if (code !== 0) {
        throw new Error(message)
      }

      return {
        active: active_project_id,
        permissions: data.perms.reduce((cum, cur) => {
          if (cur.active) {
            return {
              ...cum,
              [cur.project_id]: {
                role: cur.permission,
                levels: {
                  1: cur.level1,
                  2: cur.level2,
                  3: cur.level3,
                },
              },
            }
          } else {
            return cum
          }
        }, {}),
      }
    })
}

/**
 */
export const loadEntries = () => {
  return httpClient
    .post('/projects/view')
    .then(({ data }) => data)
    .then(({ code, data, message }) => {
      if (code !== 0) {
        throw new Error(message)
      }

      return data.map(EntityConverter.entityToModel)
    })
}

export const setActiveProject = (id) => {
  return httpClient.post('/projects/current', {
    id,
  })
}
/**
 */
export const loadEntry = (id) => {
  return httpClient
    .post('/projects/current', {
      id,
    })
    .then(({ data }) => data)
    .then(({ code, data, message }) => {
      if (code !== 0) {
        throw new Error(message)
      }

      return data
    })
    .then(EntityConverter.entityToModel)
}

/**
 */
export const registrateEntry = (data) => {
  const postData = new URLSearchParams()
  Object.entries(EntityConverter.modelToEntity(data)).forEach(([k, v]) => {
    if ((v ?? null) !== null) {
      postData.append(k, v ?? null)
    }
  })

  return httpClient
    .post('/projects/new', postData)
    .then(({ data }) => data)
    .then(({ code, data, message }) => {
      if (code !== 0) {
        throw new Error(message)
      }
      return data
    })
    .then(EntityConverter.entityToModel)
}

/**
 */
export const updateEntry = (id, data) => {
  var params = new URLSearchParams()

  Object.entries(EntityConverter.modelToEntity({ id, ...data })).forEach(
    ([k, v]) => {
      if ((v ?? null) !== null) {
        params.append(k, v ?? null)
      }
    },
  )

  return httpClient
    .post('/projects/edit', params)
    .then(({ data }) => data)
    .then(({ code, data, message }) => {
      if (code !== 0) {
        throw new Error(message)
      }
      return data
    })
    .then(() => ({ id, ...data }))
}

/**
 */
export const deleteEntry = (id, password) => {
  var params = new URLSearchParams()
  params.append('project_id', id)
  params.append('password', password)

  return httpClient
    .post('/projects/delete', params)
    .then(({ data }) => data)
    .then(({ code, data, message }) => {
      if (code !== 0) {
        switch (code) {
          case 4:
            throw 'Form.Error.IncorrectPassword'
          default:
            throw 'Form.Error.SubmitFailed'
        }
      }
      return data
    })
}

export const cloneEntry = (source, copyBoard = false, suffix = '(の複製)') => {
  return httpClient
    .post('/projects/clone', {
      project_id: source,
      suffix: suffix,
      copy_moodboards: copyBoard,
    })
    .then(({ data }) => data)
    .then(({ code, data, message }) => {
      if (code !== 0) {
        throw new Error(message)
      }
      return data
    })
}

export const invite = (project, mailAddr, perms = {}) => {
  return httpClient
    .post('/user/invite', {
      email: mailAddr,
      //lang: "ja",
      perms: {
        admin: !!perms.admin,
        delete: !!perms.delete,
        edit: !!perms.edit,
        view: !!perms.view,
      },
      project_id: project,
    })
    .then(({ data }) => data)
    .then(({ code, data, message }) => {
      if (code !== 0) {
        throw new Error(message)
      }
      return data
    })
}
